



























import Vue from 'vue';
import Component from 'vue-class-component';
import { BaseContentModel, FooterCompanyDetails, JsonContent } from '@/types/contentServerContract';
import serverContext from '@/core/serverContext.service';
import contentApi from '@/core/http/contentApi.service';
import checkoutConditionsOverlayService from '@/project/modals/overlays/CheckoutConditionsOverlay.service';

@Component
export default class CheckoutFooter extends Vue {
    conditionsShownType: 'freight' | 'terms' = 'freight';
    freightPage: BaseContentModel | null = null;
    termsPage: BaseContentModel | null = null;

    get companyDetails(): FooterCompanyDetails | null {
        return serverContext?.footer?.companyDetails;
    }

    get conditionsHeaderLabel(): string {
        return this.conditionsShownType === 'freight' ? 'Checkout.StandardFreightCosts' : 'Checkout.TradeTermsAndConditions';
    }

    get contentBlocks(): JsonContent[] {
        return this.conditionsShownType === 'freight' ? (this.freightPage?.blocks ?? []) : (this.termsPage?.blocks ?? []);
    }

    showTerms() {
        this.conditionsShownType = 'terms';
        checkoutConditionsOverlayService.show(this.conditionsHeaderLabel, this.contentBlocks);
    }

    showFreight() {
        this.conditionsShownType = 'freight';
        checkoutConditionsOverlayService.show(this.conditionsHeaderLabel, this.contentBlocks);
    }

    async created() {
        if (!serverContext.settings) return;

        contentApi.getContent<BaseContentModel>(serverContext.settings.standardFreightPage)
            .then(content => this.freightPage = content);
        contentApi.getContent<BaseContentModel>(serverContext.settings.termsPage)
            .then(content => this.termsPage = content);
    }
}
